export default {
	loadingData: 'កំពុងទាញយកទិន្នន័យ... សូមរង់ចាំ',
};
